import React from 'react';
import type { ReactNode } from 'react';
import styles from '../../styles/pages/SalesPlanPage.module.scss';

export interface StepItem {
  title: string;
  description: string;
  icon: ReactNode;
}

interface StepsNavigationProps {
  steps: StepItem[];
  currentStep: number;
  onSelect: (index: number) => void;
  additionalContent?: ReactNode;
}

const StepsNavigationComponent: React.FC<StepsNavigationProps> = ({ 
  steps, 
  currentStep, 
  onSelect,
  additionalContent 
}) => (
  <div 
    className={styles.stagesNavigation} 
    data-tour-id="stages-navigation"
    style={{
      isolation: 'isolate',
      position: 'relative',
      zIndex: 10
    }}
  >
    <div className={styles.planningStagesBlock}>
      {steps.map((step, index) => (
        <button
          key={step.title}
          className={`${styles.stageButton} ${currentStep === index ? styles.active : ''}`}
          onClick={() => onSelect(index)}
          type="button"
          aria-current={currentStep === index ? 'step' : undefined}
          data-tour-id={`stage-button-${index}`}
        >
          <div className={styles.stageContent}>
            <div className={styles.stageIcon}>{step.icon}</div>
            {step.title && <div className={styles.stageTitle}>{step.title}</div>}
            <div className={styles.stageDescription}>{step.description}</div>
          </div>
        </button>
      ))}
    </div>
    
    {additionalContent && (
      <div className={styles.stagesAdditionalContent}>
        {additionalContent}
      </div>
    )}
  </div>
);

export const StepsNavigation = React.memo(StepsNavigationComponent);

export default StepsNavigation;


